import { useEffect } from 'react'

import { useNavigate } from 'react-router'

import { IconLoading } from '@/assets/icons/icon-loading'
import { useToast } from '@/components/ui/toast.tsx'
import { useAccount } from '@/modules/accounts/hooks/useAccounts'
import { AppRoutes } from '@/utils/constants'

import { applyPromoFx } from '../models'

interface Props {
  token: string
}

export const ApplyTrialPromo: React.FC<Props> = ({ token }) => {
  const toast = useToast()
  const { isLoggedIn } = useAccount()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoggedIn) {
      toast.error(
        'You have already started your free trial. Please check your email for details.',
      )
      navigate(AppRoutes.Overview.asUrl(), { replace: true })

      return
    }
    applyPromoFx({ token })
  }, [token, isLoggedIn, toast, navigate])

  return (
    <div className="flex items-center justify-center h-screen">
      <IconLoading className="w-8 h-8 animate-spin text-primary" />
    </div>
  )
}
